import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NamirasoftJobArrangerServer } from "namirasoft-job-arranger";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { JobArrangerLayout } from "./JobArrangerLayout";
import { JobArrangerRoutes } from "./JobArrangerRoutes";
import DashboardPage from "./pages/DashboardPage";
import HomePage from "./pages/HomePage";
import JobEditPage from "./pages/JobEditPage";
import JobListPage from "./pages/JobListPage";
import JobViewPage from "./pages/JobViewPage";
import LoginPage from "./pages/LoginPage";
import PlatformListPage from "./pages/PlatformListPage";
import ReasonEditPage from "./pages/ReasonEditPage";
import ReasonListPage from "./pages/ReasonListPage";
import ReasonViewPage from "./pages/ReasonViewPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_JOB_ARRANGER}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_JOB_ARRANGER = new EnvService("REACT_APP_BASE_URL_JOB_ARRANGER", true).getString();

            let job_arranger = new NamirasoftJobArrangerServer(REACT_APP_BASE_URL_JOB_ARRANGER, result.account.token_manager, result.notifier.onError);

            let servers = { job_arranger };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={JobArrangerRoutes.Home} element={<HomePage {...result} servers={servers} />} />
                            <Route path={JobArrangerRoutes.Dashboard} element={<DashboardPage {...result} servers={servers} />} />
                            <Route path={JobArrangerRoutes.PlatformList} element={<PlatformListPage {...result} servers={servers} />} />

                            <Route path={JobArrangerRoutes.JobList} element={<JobListPage {...result} servers={servers} />} />
                            <Route path={JobArrangerRoutes.JobNew} element={<JobEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={JobArrangerRoutes.JobView(":id")} element={<JobViewPage {...result} servers={servers} />} />
                            <Route path={JobArrangerRoutes.JobEdit(":id")} element={<JobEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={JobArrangerRoutes.JobCopy(":id")} element={<JobEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={JobArrangerRoutes.ReasonList} element={<ReasonListPage {...result} servers={servers} />} />
                            <Route path={JobArrangerRoutes.ReasonNew} element={<ReasonEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={JobArrangerRoutes.ReasonView(":id")} element={<ReasonViewPage {...result} servers={servers} />} />
                            <Route path={JobArrangerRoutes.ReasonEdit(":id")} element={<ReasonEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={JobArrangerRoutes.ReasonCopy(":id")} element={<ReasonEditPage {...result} servers={servers} isEdit={false} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={JobArrangerRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <JobArrangerLayout {...props}>
                {props.children}
            </JobArrangerLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: false
            }
        }}
    />
}

export default Router;